"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _useSystemLinks = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useSystemLinks"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _CartContext = _interopRequireDefault(require("../../../context/CartContext"));
var _ShopContext = _interopRequireDefault(require("../../../context/ShopContext"));
var _submit = _interopRequireWildcard(require("../../../utils/cart/submit"));
var _updateCustomerAddress = _interopRequireDefault(require("../../../utils/cart/updateCustomerAddress"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _BillingAddress = _interopRequireDefault(require("../BillingAddress"));
var _CartItem = _interopRequireDefault(require("../../../components/Cart/CartItem"));
var _DataPrivacy = _interopRequireDefault(require("../DataPrivacy"));
var _Headline = _interopRequireDefault(require("../../../components/views/Headline"));
var _Price = _interopRequireDefault(require("../../../components/Cart/Price"));
var _TotalPrice = _interopRequireDefault(require("../../../components/Cart/TotalPrice"));
var _Billing = _interopRequireDefault(require("../Billing"));
var _PaymentMethod = _interopRequireDefault(require("../PaymentMethod"));
var _RewardPoints = _interopRequireDefault(require("../RewardPoints"));
var _ShippingAddress = _interopRequireDefault(require("../ShippingAddress"));
var _ShippingProviders = _interopRequireDefault(require("../ShippingProviders"));
var _Message = _interopRequireDefault(require("../Message"));
var _Voucher = _interopRequireDefault(require("../Voucher"));
var _Overview = _interopRequireDefault(require("./Overview.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const LoadingIcon = (0, _component.default)(() => import("../../../components/LoadingIcon"));
const UserConnection = (0, _component.default)(() => import("@micado-digital/react-user-connection/ReactUserConnection"));
const Overview = _ref => {
  let {
    defaultLang = "de"
  } = _ref;
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang: pageDataLang
  } = pageData || {};
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const {
    rewardPoints
  } = shopData || {};
  const {
    cart,
    cartRef,
    setCart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    address: {
      billing: {
        customerAddressID: billingID
      } = {},
      shipping: {
        customerAddressID: shippingID
      } = {}
    } = {},
    isGuest = false,
    items = [],
    prices,
    _loading = false
  } = cart || {};
  const [accepted, setAccepted] = (0, _react.useState)(false);
  const [customerTaxCode, setCustomerTaxCode] = (0, _react.useState)("");
  const [error, setError] = (0, _react.useState)(false);
  const [lang, setLang] = (0, _react.useState)(defaultLang);
  const [loading, setLoading] = (0, _react.useState)(false);
  const [message, setMessage] = (0, _react.useState)("");
  const [messageObj, setMessageObj] = (0, _react.useState)({});
  const [sendBill, setSendBill] = (0, _react.useState)(false);
  const theme = (0, _useTheme.default)();
  const isMobile = (0, _useMediaQuery.default)(theme.breakpoints.down(1200));
  const navigate = (0, _useLink.default)();
  const systemLink = (0, _useSystemLinks.default)();
  const css = (0, _Overview.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const confirmationUrl = systemLink("shop-payment-success");
  (0, _react.useEffect)(() => {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  (0, _react.useEffect)(() => {
    if (!accepted) return;
    setError(false);
    setMessageObj({});
  }, [accepted]);
  const entries = (0, _react.useMemo)(() => {
    var _items$length;
    return (_items$length = items.length) !== null && _items$length !== void 0 ? _items$length : 0;
  }, [items]);
  const handleSubmit = async () => {
    if (!accepted) {
      setError(true);
      setMessageObj({
        message: l("reactShop.messages.errors.DATA_PRIVACY_NOT_ACCEPTED"),
        type: "error"
      });
      return;
    }
    setLoading(true);
    clearInterval(cartRef === null || cartRef === void 0 ? void 0 : cartRef.current);
    const response = await (0, _submit.default)({
      customerTaxCode,
      message,
      sendBill
    });
    const {
      msg,
      paymentURL,
      paymentTransactionID,
      paymentType
    } = response || {};
    setLoading(false);
    if (msg) {
      setMessageObj({
        message: l("reactShop.messages.errors.".concat(_submit.SUBMIT_ERRORS[msg])),
        type: "error"
      });
      return;
    }
    localStorage.setItem("mco-shop-order", JSON.stringify(response));

    // Replace point, because of invalid url

    if (paymentType === "hobex" && paymentTransactionID) {
      navigate("/".concat(lang, "/shop/payment/hobex/").concat(decodeURI(paymentTransactionID.replace(".", "-"))));
      return;
    }
    if (paymentURL) {
      window.location.href = paymentURL;
      return;
    }
    navigate(confirmationUrl ? confirmationUrl : "/".concat(lang, "/shop/confirmation"));
  };
  const handleConnectionChange = (0, _react.useCallback)(async connection => {
    const {
      identifier
    } = connection || {};
    if (!identifier) return;
    const response = await (0, _updateCustomerAddress.default)({
      billingID: billingID !== null && billingID !== void 0 ? billingID : 0,
      shippingID: shippingID !== null && shippingID !== void 0 ? shippingID : 0,
      type: "both",
      customerIdentifier: identifier
    });
    const {
      msg
    } = response || {};
    if (msg) {
      return;
    }
    localStorage.setItem("mco-shop-cart", JSON.stringify(response));
    setCart(response);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [billingID, shippingID]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.overview, "mco-shop-checkout-overview")
  }, /*#__PURE__*/_react.default.createElement(_Headline.default, {
    headline: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.checkout.headline",
      l: l
    })
  }), /*#__PURE__*/_react.default.createElement(UserConnection, {
    applicationType: "micadoshop",
    lang: lang,
    localStorageKey: "mco-shop-connection",
    onChange: handleConnectionChange
  }), entries > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.wrapper, "mco-shop-checkout__wrapper")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.rightColumn, "mco-shop-checkout__right-column")
  }, /*#__PURE__*/_react.default.createElement(_ShippingAddress.default, {
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_BillingAddress.default, {
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_PaymentMethod.default, {
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_Voucher.default, {
    lang: lang
  }), isMobile && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.dataPrivacy, "mco-shop-checkout__data-privacy")
  }, /*#__PURE__*/_react.default.createElement(_DataPrivacy.default, {
    accepted: accepted,
    error: error,
    lang: lang,
    setAccepted: setAccepted
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.priceWrapper, "mco-shop-checkout__price-wrapper")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.price, "mco-shop-checkout__price")
  }, /*#__PURE__*/_react.default.createElement(_Price.default, {
    lang: lang,
    prices: prices
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.totalPrice, "mco-shop-checkout__total-price")
  }, /*#__PURE__*/_react.default.createElement(_TotalPrice.default, {
    lang: lang,
    prices: prices
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _clsx.default)(css.button, "mco-shop-checkout__button", {
      [css.isLoading]: loading
    }),
    color: "primary",
    disabled: loading,
    fullWidth: true,
    variant: "contained",
    onClick: handleSubmit
  }, loading ? /*#__PURE__*/_react.default.createElement(LoadingIcon, null) : /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.checkout.buttons.buyNow",
    l: l
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.content, "mco-shop-checkout__content")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.shippingProviders, "mco-shop-checkout__shipping-providers")
  }, /*#__PURE__*/_react.default.createElement(_ShippingProviders.default, {
    lang: lang
  })), items === null || items === void 0 ? void 0 : items.map(item => {
    const {
      guid
    } = item;
    return /*#__PURE__*/_react.default.createElement(_CartItem.default, _extends({
      key: guid,
      lang: lang
    }, item));
  }), !isGuest && !(0, _isEmpty.default)(rewardPoints) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.rewardPoints, "mco-shop-checkout__reward-points")
  }, /*#__PURE__*/_react.default.createElement(_RewardPoints.default, {
    lang: lang,
    setMessageObj: setMessageObj
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.billing, "mco-shop-checkout__billing")
  }, /*#__PURE__*/_react.default.createElement(_Billing.default, {
    customerTaxCode: customerTaxCode,
    lang: lang,
    sendBill: sendBill,
    setCustomerTaxCode: setCustomerTaxCode,
    setSendBill: setSendBill
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.message, "mco-shop-checkout__message")
  }, /*#__PURE__*/_react.default.createElement(_Message.default, {
    value: message,
    setValue: setMessage
  })), !isMobile && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.dataPrivacy, "mco-shop-checkout__data-privacy")
  }, /*#__PURE__*/_react.default.createElement(_DataPrivacy.default, {
    accepted: accepted,
    error: error,
    lang: lang,
    setAccepted: setAccepted
  })), !(0, _isEmpty.default)(messageObj) && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    className: (0, _clsx.default)(css.errorMessage, "mco-shop-checkout__error-message"),
    severity: messageObj === null || messageObj === void 0 ? void 0 : messageObj.type
  }, messageObj === null || messageObj === void 0 ? void 0 : messageObj.message)))), entries === 0 && !_loading && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.wrapper, "mco-shop-checkout__wrapper")
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    severity: "error",
    className: "mco-shop-checkout__error"
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.messages.errors.CHECKOUT_NO_ITEMS",
    l: l
  }))));
};
var _default = exports.default = Overview;